(() => {
  const root=document.querySelector('.cx-full-home');
  if(!root||!('IntersectionObserver' in window))return;
  const reduced=matchMedia('(prefers-reduced-motion: reduce)');
  const animations=new Set();
  const play=(el,frames,delay=0)=>{
    if(reduced.matches||!el.animate)return;
    const animation=el.animate(frames,{duration:480,delay,easing:'cubic-bezier(.16,1,.3,1)',fill:'backwards'});
    animations.add(animation);
    animation.finished.catch(()=>{}).finally(()=>animations.delete(animation));
  };
  const press=root.querySelector('.recognition-grid');
  if(press){
    press.classList.remove('reveal');
    const observer=new IntersectionObserver(entries=>{
      if(!entries.some(e=>e.isIntersecting))return;
      play(press,[{clipPath:'inset(0 100% 0 0)'},{clipPath:'inset(0)'}]);
      press.querySelectorAll('.recognition-item').forEach((el,i)=>{
        play(el,[{opacity:.15,translate:'0 12px'},{opacity:1,translate:'0 0'}],100+i*70);
      });
      observer.disconnect();
    },{threshold:.15});
    observer.observe(press);
    press.addEventListener('focusin',()=>animations.forEach(a=>a.finish()));
  }
  const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{
    if(!entry.isIntersecting)return;
    play(entry.target,[{clipPath:'inset(8% 0 8% 0)',opacity:.5},{clipPath:'inset(0)',opacity:1}]);
    observer.unobserve(entry.target);
  }),{threshold:.12});
  root.querySelectorAll('.cm-shop-demo,.grip-stage .video-player,.detail-strip figure').forEach(el=>observer.observe(el));
  reduced.addEventListener('change',()=>{if(reduced.matches)animations.forEach(a=>a.finish());});
})();
